import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import routes from './routes';
import { Router } from 'react-router';
import { CookiesProvider } from 'react-cookie';

export default class Root extends Component {
    render() {
        const {store, history} = this.props;
        return (
            <Provider store={store}>
                <CookiesProvider>
                    <Router onUpdate={() => window.scrollTo(0, 0)} history={history} routes={routes}/>
                </CookiesProvider>
            </Provider>
        );
    }
}

Root.propTypes = {
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/Root.js